export default __webpack_public_path__ + "images/loggedout/home/modularPage/white_curve-4291f06f34743d2359dd498f2eda92de.png";